import { Button } from 'flowbite-react'
import Link from 'next/link'
import { twMerge } from 'tailwind-merge'

export interface CtaPanelProps {
  header: string
  subHeader: string
  cta: {
    text: string
    url: string
  }
  className?: string
}

export const CtaPanel = ({
  header,
  subHeader,
  cta,
  className,
}: CtaPanelProps) => {
  return (
    <div className={twMerge('flex flex-col py-10 items-center', className)}>
      <div className="max-w-xl flex flex-col items-center gap-6">
        <div className="space-y-2">
          <p className="text-gray-900 font-semibold text-lg text-center">
            {header}
          </p>
          <p className="text-gray-500 text-center">{subHeader}</p>
        </div>
        <Button
          className="w-full max-w-sm"
          color="dark"
          as={Link}
          href={cta.url}
        >
          {cta.text}
        </Button>
      </div>
    </div>
  )
}
